import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-taxcode-exemptionrate-select',
  templateUrl: './taxcode-exemptionrate-select.component.html',
  styles: [],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TaxExemptionRateSelectComponent),
      multi: true
    }
  ]
})
export class TaxExemptionRateSelectComponent implements ControlValueAccessor {
  statusLabel: { [key: number]: string } = {};
  exemptedGovTaxCodes = ['SVTE', 'SVTDE', 'SVTEGR', 'SVTEOTH', 'IMSVTE'];

  @Input() value = 0;
  @Input() govTaxCode = '';
  @Input() disabled = false;
  @Input() allowEdit = true;
  @Input() borderless = false;

  get readonly() {
    if (this.disabled || !this.allowEdit) {
      return true;
    }
    return false;
  }

  get exemptedRateOptions() {
    const govTaxCode = this.govTaxCode;
    if (this.exemptedGovTaxCodes.includes(govTaxCode)) {
      return [
        { value: 0.06, label: '6%' },
        { value: 0.08, label: '8%' }
      ];
    } else {
      return [{ value: 0, label: '0%' }];
    }
  }

  get displayText() {
    const item = this.exemptedRateOptions.find(x => x.value === this.value);
    if (this.govTaxCode === '') return '';
    if (this.value === 0) return '0%';
    if (item) return item.label;
    return this.value ? `${this.value * 100}%` : '';
  }

  onChange: any = () => {};
  onTouched: any = () => {};
  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: number): void {
    this.value = value;
    this.onChange(value);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    this.value = val;
    this.onChange(val);
    this.cdr.markForCheck();
  }
}
